<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.privacy-section-2
        class="text-left fw-500 d-flex align-items-center justify-content-between">
            <div>
                <span class="box-numbering">02</span>
                <span>Information We Collect We may collect</span>    
            </div>
            <span 
                class="toggle-icon" 
                :class="{ active: isOpen }"
            >
                <span class="plus">+</span>
                <span class="cross">×</span>
            </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="privacy-section-2"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Personal Information: Name, contact details (phone number, email
            address), address, date of birth, identification documents (e.g.,
            passport, national ID), and other relevant information required for
            identification and verification.
          </p>
          <p class="text-justify">
            Usage Data: Information on how you interact with our services,
            including transaction data, device identifiers, IP addresses, and
            cookies.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-2",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
